export default __webpack_public_path__ + "static/media/cp_geo_ke.55d663b2.svg";